import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	getStaffBenefitsReport,
	indexStaffMembersBenefits,
} from "~/modules/humanResources/api/staffMemberBenefit/staffMemberBenefitApiDispatchers.ts";

export const STAFF_MEMBER_BENEFIT_BASE_QUERY_KEY = "staffMembersBenefit";

export const STAFF_MEMBERS_BENEFITS_QUERY_KEY = (staffMemberId: string) => [STAFF_MEMBER_BENEFIT_BASE_QUERY_KEY, staffMemberId];

export const useStaffMembersBenefits = (staffMemberId:string) => useQuery({
    queryKey: STAFF_MEMBERS_BENEFITS_QUERY_KEY(staffMemberId),
    queryFn: () => indexStaffMembersBenefits(staffMemberId).then(getDataFromResponse),
	enabled: !!staffMemberId,
});

export const STAFF_MEMBER_BENEFIT_REPORT_QUERY_KEY = ["staff-benefits-report"];

export const useStaffMembersBenefitsReport = () => useQuery({
	queryKey: STAFF_MEMBER_BENEFIT_REPORT_QUERY_KEY,
	queryFn: ()=>getStaffBenefitsReport().then(getDataFromResponse),
});